module.exports = __webpack_public_path__ + "static/media/Retro-Sprint-4-Audio-2.d9ea81ef.mp3";